import React, { useEffect, useState } from 'react';
import { isEmptyValue } from 'utils';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { ResultEnergy, SettingEnergy } from 'components';

import simulationService from 'services/simulation/simulation-service';
import _ from "lodash";

const spaceHeader = [
  '',
  '높이(h1)',
  '용마루 높이(h2)',
  '길이(L)',
  '너비(W)',
];

const defaultValue = {
  name: '',
  case1: [
    {
      height1: '',
      height2: '',
      length: '',
      width: '',
    },
  ],
};

const defaultInvalid = {
  height1: { type: '', text: '이 시뮬레이션 명은 사용중입니다. 다른 시뮬레이션 명을 입력해 주세요.' },
  height2: '',
  length: { type: '', text: '목표 온도는 40℃를 초과하여 입력할 수 없습니다.' },
};

export function Energy(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const type = searchParams.get('type') || '0';
  const [active, setActive] = useState(false);
  const [values, setValues] = useState(defaultValue);
  const [chartData, setChartData] = useState([]);

  const [invalids, setInvalids] = useState(defaultInvalid);

  const onChange = (name, val) => {

    // 영어 대소문자만 남기도록 val을 필터링합니다.
    if (name === 'name') {
      const filteredVal = val.replace(/[^A-Za-z]/g, '');
      val = filteredVal;
    }

    // 숫자와 '.'만 남기도록 val을 필터링하고, 'e'는 허용하지 않습니다.
    if (['case1.height1', 'case1.height2', 'case1.length', 'case1.width'].includes(name)) {
      // 여기서 'e'를 포함하는지 직접 확인하고 제거합니다.
      if (val.includes('e') || val.includes('E')) {
        val = val.replace(/e/gi, ''); // e 또는 E 제거
      }

      // 숫자와 소수점 이외의 문자를 필터링합니다.
      const filteredVal = val.replace(/[^0-9.]/g, '');

      // 만약 입력 값에 숫자나 '.' 이외의 문자가 있었다면, 기존 값을 그대로 사용합니다.
      if (filteredVal !== val) {
        val = filteredVal;
      }
    }

    // if (['case1', 'case2', 'case3'].includes(name.split('.')[0])) {
    if (['case1'].includes(name.split('.')[0])) {
      const [casesName, key] = name.split('.');
      setValues((prev) => ({
        ...prev,
        [casesName]: prev[casesName].map((item) => ({
          ...item,
          [key]: val,
        })),
      }));
    } else {
      setValues((prev) => ({ ...prev, [name]: val }));
      const tempInvalids = { ...invalids };

      if (name === 'length') {
        if (parseFloat(val) > 40) {
          tempInvalids.length.type = 'error';
        } else {
          tempInvalids.length.type = '';
        }
      }

      setInvalids(tempInvalids);
    }
  };

  const reset = () => {
    setValues(defaultValue);
    setInvalids(defaultInvalid);
  };

  useEffect(() => {
    if (!isEmptyValue(values)) {
      setActive(true);
    } else {
      setActive(false);
    }
  }, [values]);

  const submit = () => {
    // setValues(defaultValue);
    navigate(`/energy?type=1`);

    const params = {
      name: values.name,
      height1: values.case1[0].height1,
      height2: values.case1[0].height2,
      length: values.case1[0].length,
      width: values.case1[0].width
    }
    simulationService.getSimulationEnergyForecast(params).then((data) => {

      setChartData(data);
    });
  };

  useEffect(() => {
    if (type === '0' && location.pathname === '/energy') {
      setSearchParams({ type: '0' }, { replace: true });
    }
  }, [type, setSearchParams]);

  return (
    <>
      {type === '0' && (
        <SettingEnergy
          spaceHeader={spaceHeader}
          values={values}
          onChange={onChange}
          invalids={invalids}
          active={active}
          reset={reset}
          submit={submit}
        />
      )}
      {type === '1' && <ResultEnergy chartData={chartData}/>}
    </>
  );
}
